import script from "./WebVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./WebVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./WebVideoPlayer.vue?vue&type=style&index=0&id=59d2755b&scoped=true&lang=scss"
import "./WebVideoPlayer.vue?vue&type=style&index=1&id=59d2755b&lang=scss"
import "./WebVideoPlayer.vue?vue&type=style&index=2&id=59d2755b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d2755b"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSpinnerTail from 'quasar/src/components/spinner/QSpinnerTail.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QScrollArea,QSpinnerTail,QIcon,QInput});
